import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Bannerfrom from "../components/bannerfrom";

function Banner({ data }) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Business">
                <h1>Custom Dot NET Software Development Company in USA</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  TekRevol is an ASP.NET development company that uses the .NET
                  platform to build state-of-the-art software systems for
                  businesses. Our technologies using .NET can help you in every
                  walk of life.
                </p>
                <ul>
                  <li>Expert ASP.NET Developers</li>
                  <li>State-of-the-art Solutions</li>
                  <li>Custom .NET Development</li>
                  <li>Innovative Technology Solutions.</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
